import { endpoints, host } from '@config/endpoints';
import { paramsToString } from '@helpers/paramsToString';
import request from './request';

export interface TCountriesParams {
    page?: number;
    limit?: number;
    sortField?: string;
    sortOrder?: 'desc' | 'asc';
}

export const getCountries = async (
    page = 0,
    limit = 300,
    sortField = 'country',
    sortOrder = 'asc',
) => {
    const params = {
        page,
        limit,
        sortField,
        sortOrder,
    };
    const { path, method } = endpoints.hubs.all;

    let err = null;
    let res: any = null;

    const stringOfParams = paramsToString(params);

    try {
        ({ data: res } = await request(
            `${host}${path}${stringOfParams}`,
            method,
            {},
            {},
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
